import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants"

export const ADMIN_LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']

export const SEAMLESSVIEW_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'State Boundary': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'SEAMLESSVIEW_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'State Boundaries': {
            source: 'INDIA',
            displayName: 'State Boundaries',
            name: 'State Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundaries',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundaries': {
            source: 'INDIA',
            displayName: 'District Boundaries',
            name: 'District Boundaries',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundaries',
            layeroptions_pane: 'max',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            type: LAYER_TYPES.GEOJSON_LAYER,
            cql_filter_value: 'uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_protocol: 'WFS'
        },
        'District Boundary': {
            source: 'INDIA',
            displayName: 'District',
            name: 'District Boundary',
            visible: true,
            // hasLegend: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundary',
            layeroptions_pane: 'depth',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'SEAMLESSVIEW_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'Block Boundary': {
            source: 'INDIA',
            displayName: 'Block',
            name: 'Block Boundary',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            layer_name: 'Block Boundary',
            layeroptions_pane: 'state',
            // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            type: LAYER_TYPES.VECTOR_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
            crs: 'EPSG4326',
            hasLables: true,
            applycql_filter: true,
            legendName: 'SEAMLESSVIEW_LEGEND',
            layeroptions_protocol: 'WFS'
        },
        'State Boundary Labels': {
            source: 'INDIA',
            displayName: 'State',
            name: 'State Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE_UPDATED',
            layer_name: 'State Boundary',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES_UPDATED',
            crs: 'EPSG4326',
        },
        'District Boundary Labels': {
            source: 'INDIA',
            displayName: 'District Boundary Labels',
            name: 'District Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT_UPDATED',
            layer_name: 'District Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'state_uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_DISTRICT_NAMES_UPDATED',
            crs: 'EPSG4326',
        },
        'Block Boundary Labels': {
            source: 'INDIA',
            displayName: 'Block Boundary Labels',
            name: 'Block Boundary Labels',
            visible: true,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS_UPDATED',
            layer_name: 'Block Boundary Labels',
            layeroptions_pane: 'depth',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
            group: 'Labels',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: 'dist_uuid',
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            environment_server_url: 'COMMON_GEOSERVER_URL',
            layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_LABELS_UPDATED',
            crs: 'EPSG4326',
        }
    }
}

export const SEAMLESSVIEW_HEATMAP_LAYERLIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        'HEATMAP': {
            source: 'INDIA',
            displayName: 'HEATMAP',
            name: 'HEATMAP',
            visible: false,
            // type: 'time',
            groupName: null,
            view: AgricultureMapConstants.VIEWS.ADMIN,
            dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            layerptions_show_on_selector: false,
            // layeroptions_name: 'HEATWAVE:GPM_Model_2_EV_input_25Apr2025_1430',
            layeroptions_name: 'HEATWAVE:observed',
            layer_name: 'HEATMAP',
            layeroptions_pane: 'state',
            layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            group: 'boundaries',
            group_type: 'radio-deselect',
            layerServiceType: LAYER_TYPES.WMS_LAYER,
            type: LAYER_TYPES.WMS_LAYER,
            cql_filter_value: null,
            cql_filter: null,
            layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            // onEachFeature: 'handleAdminPolygons',
            environment_server_url: 'COMMON_GEO_URL',
            applycql_filter: true,
            crs: 'EPSG4326',
            // layeroptions_styles: 'HEATWAVE:nowcast_geotiff',
            layeroptions_styles: 'HEATWAVE:radar_geotiff',
            // layeroptions_protocol: 'WFS'
        },
    }
}

export const SEAMLESSVIEW_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        IMD_RADAR_MODEL_INPUT_NOWCAST: {
            SEAMLESSVIEW_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>70'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#ffffff',
                        text: '65'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '60'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '55'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '50'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '45'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '40'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '35'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '30'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '25'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '20'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '15'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '10'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '5'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0'
                    }
                ],
                Units: 'dbZ'
            }
        },
        CTT_MODEL_INPUT_NOWCAST: {
            SEAMLESSVIEW_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '>40.0'
                    },
                    {
                        backgroundColor: '#b3cce6',
                        textColor: '#000000',
                        text: '30.0'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '20.0'
                    },
                    {
                        backgroundColor: '#b3cce6',
                        textColor: '#000000',
                        text: '10.0'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '00.0'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '-10'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '-20'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '-33'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '-40.5'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '-48'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '-55.5'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '-63'
                    },
                    {
                        backgroundColor: '#b41b01',
                        textColor: '#ffffff',
                        text: '-70.5'
                    },
                    {
                        backgroundColor: '#9e1001',
                        textColor: '#ffffff',
                        text: '-78'
                    },
                    {
                        backgroundColor: '#e0b3b3',
                        textColor: '#000000',
                        text: '-85.5'
                    },
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '-93'
                    }
                ],
                Units: '(°C)'
            }
        },
        EUMETSAT_MODEL_INPUT_NOWCAST: {
            SEAMLESSVIEW_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>100'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#000000',
                        text: '75'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '50'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '40'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '30'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#000000',
                        text: '20'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#000000',
                        text: '10'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '2.5'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0.5'
                    }
                ],
                Units: 'mm/hr'
            }
        },
        MODEL_INPUT_NOWCAST: {
            SEAMLESSVIEW_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: 'transparent',
                        textColor: '#000000',
                        text: '0-0.5'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0.5-2.5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '2.5-5'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '5-10'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '10-20'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '20-30'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '30-40'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '40-50'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#ffffff',
                        text: '50-75'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#ffffff',
                        text: '75-100'
                    },
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>100'
                    },

                  ],
                Units: 'mm/hr'
            }
        }
    }
}

export const SEAMLESSVIEW_SOURCES: any = {
    IMD_RADAR_NOWCAST: 'IMD RADAR (RAINFALL)',
    IMD_RADAR_MODEL_INPUT_NOWCAST: 'dbZ',
    CTT_MODEL_INPUT_NOWCAST: 'CTT',
    EUMETSAT_MODEL_INPUT_NOWCAST: 'EUMETSAT',
    MODEL_INPUT_NOWCAST: 'RADAR+CTT',
}

export const SEAMLESSVIEW_TITLE: any = {
    IMD_RADAR_NOWCAST: 'IMD RADAR (mm/hr)',
    IMD_RADAR_MODEL_INPUT_NOWCAST: 'RADAR ( dbZ )',
    CTT_MODEL_INPUT_NOWCAST: 'CTT ( °C )',
    EUMETSAT_MODEL_INPUT_NOWCAST: 'EUMETSAT ( mm/hr )',
    MODEL_INPUT_NOWCAST: 'RAINFALL ( mm/hr )',
}

export const SeamlessviewMapConstants: any = {
    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    }
}

export const SEAMLESSVIEW_SOURCE_MAPPING: any = {
    'RICKEN': { 'source': 'RICKEN_NOWCAST', 'displaySource': 'JAXA' },
    'RADAR': { 'source': 'SIMPLE_RADAR_NOWCAST', 'displaySource': 'RAIN VIEWER' },
    'IMD RADAR': { 'source': 'IMD_RADAR_NOWCAST', 'displaySource': 'IMD' },
    'RADAR+CTT': { 'source': 'RADAR_CTT_EUMETSAT_NOWCAST', 'displaySource': 'IMD, EUMETSAT' }
}
